(function() {
  var Controller,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.DashboardController = (function(superClass) {
    extend(DashboardController, superClass);

    function DashboardController(scope, state1, http, session, router, window) {
      this.scope = scope;
      this.state = state1;
      this.http = http;
      this.session = session;
      this.router = router;
      this.window = window;
      this.settingDefault = false;
      this.hasDefault = false;
      this.experiences = [];
      this.show = false;
      this.carouselOptions = {
        pixelsPerClick: 245
      };
      this.scope.$on('dashboard:closed', (function(_this) {
        return function() {
          return _this.settingDefault = false;
        };
      })(this));
      this.http.get('backend/dashboard/user-experiences').then((function(_this) {
        return function(experiences) {
          var company, experience, ref, state;
          if ((ref = _this.scope.$parent.drop) != null) {
            ref.show = experiences.data.length > 1;
          }
          _this.experiences = experiences.data.sort(function(experienceA, experienceB) {
            return experienceA.text.localeCompare(experienceB.text);
          }).sort(function(experienceA, experienceB) {
            return experienceA.company.localeCompare(experienceB.company);
          });
          _this.hasDefault = !!((function() {
            var i, len, ref1, results;
            ref1 = this.experiences;
            results = [];
            for (i = 0, len = ref1.length; i < len; i++) {
              experience = ref1[i];
              if (experience["default"]) {
                results.push(experience);
              }
            }
            return results;
          }).call(_this)).length;
          _this.show = true;
          if (_this.state.includes('grower')) {
            state = 'grower';
          } else if (_this.state.includes('portal')) {
            state = 'portal';
          }
          if (state) {
            company = _this.session.get("SelectedCompany-" + state);
            if (!company) {
              _this.router.determineDestination({
                r: state
              });
              return;
            }
            if (_.filter(_this.experiences, {
              state: state,
              company: company
            }).length === 0) {
              _this.router.determineDestination({
                r: state
              });
            }
          }
        };
      })(this));
    }

    DashboardController.prototype.setDefault = function() {
      return this.settingDefault = !this.settingDefault;
    };

    DashboardController.prototype.setDefaultTo = function(experience) {
      return this.http.post('backend/dashboard/set-default', experience).then((function(_this) {
        return function() {
          var exp, i, len, ref, results;
          _this.settingDefault = false;
          _this.hasDefault = experience != null;
          ref = _this.experiences;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            exp = ref[i];
            results.push(exp["default"] = exp === experience);
          }
          return results;
        };
      })(this));
    };

    DashboardController.prototype.experienceClicked = function(experience) {
      var currentApp, url;
      if (this.settingDefault) {
        return this.setDefaultTo(experience);
      } else {
        this.session.set("SelectedCompany-" + experience.state, experience.company);
        currentApp = this.state.$current.name.split('.')[0];
        if (experience.state === currentApp || currentApp === 'dashboard') {
          this.state.go(experience.state, {}, {
            reload: true
          });
        } else {
          this.scope.$emit('dashboard:close');
          url = experience.state;
          if (this.userId === 814) {
            this.state.go(experience.state, {}, {
              reload: true
            });
          } else {
            this.window.open(this.window.location.origin + "/" + url);
          }
        }
      }
    };

    return DashboardController;

  })(Controller);

}).call(this);
